import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';
import { MatRippleModule } from '@angular/material/core';
import { TranslateModule } from '@ngx-translate/core';

import { OFFER_TYPE } from '../../../models/offer-utils';
import { AppWizardService } from '../../../services/app-wizard.service';

@Component({
	selector: 'copo-dialog-new-offer-request',
	templateUrl: './dialog-new-offer-request.component.html',
	styleUrl: './dialog-new-offer-request.component.css',

	imports: [TranslateModule, MatRippleModule, MatDialogModule, MatIconModule, MatButtonModule]
})

export class DialogNewOfferRequestComponent {
	constructor(
		private readonly appWizardService: AppWizardService
	) {}

	async setOfferType(value: string) {
		sessionStorage.setItem(OFFER_TYPE, value);
		await this.appWizardService.actionNewOffer();
	}
}
